export default {
  ft: (featureName, string, t, params = {}) => {
    const translationKey = `${featureName}.${string}`
    const translationResult = t(translationKey, params)
    if (translationResult === translationKey) {
      // no translation found for this featureName, fallback to 'whistleblower' (base feature)
      return t(`whistleblower.${string}`, params)
    }
    return translationResult
  },
  featureToggles: {
    // could later be given by backend
    whistleblower: {
      reportingChannel: {
        digitalReport: { name: 'digital-report', enabled: true },
        physicalMeeting: { name: 'physical-meeting', enabled: true },
        phoneCall: { name: 'phone-call', enabled: true }
      }
    },
    harassment: {
      reportingChannel: {
        digitalReport: { name: 'digital-report', enabled: true },
        physicalMeeting: { name: 'physical-meeting', enabled: false },
        phoneCall: { name: 'phone-call', enabled: false }
      }
    }
  }
}
